import React, { memo } from 'react';

import { Container, Svg } from '@lglp/components';

function DownloadIcon({ className, ...rest }) {
  return (
    <Container className={['download-icon', className]} {...rest}>
      <Svg viewBox="0 0 22 28" className="download-icon_arrow">
        <path d="M11 1 V26 M7 20 L11 26 L15 20" />
      </Svg>
      <Svg viewBox="0 0 22 28" className="download-icon_line">
        <path d="M0 27 H22" />
      </Svg>
    </Container>
  );
}

export default memo(DownloadIcon);
